/**
 * Convert Firestore Timestamp, seconds-based object, ISO string, or Date to a JS Date.
 * @param {*} value
 * @returns {Date | null}
 */
export function normalizeFirestoreDate(value) {
  if (value == null) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value.toDate === "function") {
    try {
      const d = value.toDate();
      return Number.isNaN(d.getTime()) ? null : d;
    } catch {
      return null;
    }
  }
  if (typeof value === "object" && typeof value.seconds === "number") {
    const d = new Date(value.seconds * 1000);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Parse mobile `dateIndex` strings (YYYY-MM-DD) to local calendar Date (midnight).
 * Used for **health** check-ins where the mobile app stamps a calendar day; not used for workouts.
 * @param {string | undefined} ymd
 * @returns {Date | null}
 */
export function parseDateIndexYmd(ymd) {
  if (!ymd || typeof ymd !== "string") return null;
  const m = ymd.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Calendar day for a workout session: **when it was completed** (`completedOn`), else when it was
 * started (`createdOn` — in-progress or missing completion). We do **not** use `dateIndex` for
 * workouts: on mobile it is derived from session start, not finish, so it can be days earlier than
 * the actual workout day.
 *
 * @param {object} workout - reportExercise doc
 * @returns {Date | null}
 */
export function getWorkoutCalendarDate(workout) {
  if (!workout) return null;
  const completed = normalizeFirestoreDate(workout.completedOn);
  if (completed) return completed;
  return normalizeFirestoreDate(workout.createdOn);
}
